import { render, staticRenderFns } from "./AssessmentForm.vue?vue&type=template&id=9002afb8&scoped=true"
import script from "./AssessmentForm.vue?vue&type=script&lang=js"
export * from "./AssessmentForm.vue?vue&type=script&lang=js"
import style0 from "./AssessmentForm.vue?vue&type=style&index=0&id=9002afb8&prod&scoped=true&lang=css"
import style1 from "./AssessmentForm.vue?vue&type=style&index=1&id=9002afb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9002afb8",
  null
  
)

export default component.exports